import { render, staticRenderFns } from "./ChecklistNotifiableModal.vue?vue&type=template&id=6b7ac58d&"
import script from "./ChecklistNotifiableModal.vue?vue&type=script&lang=ts&"
export * from "./ChecklistNotifiableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports